module.exports = __webpack_public_path__ + "static/media/colheitadeira2.1fd4e7c1.svg";